import {createFeatureSelector, createSelector} from '@ngrx/store';
import {routerStateConfig} from '../../route/ngrx-router.module';
import * as fromRoot from '../../route/ngrx-router.module';
import * as fromAuth from '../../auth/auth.state';

export const getRootReducerState = createFeatureSelector<fromRoot.RootState>(routerStateConfig.stateKey);
export const getAuth= createSelector(getRootReducerState, (routerReducerState) => routerReducerState.auth);
export const selectIsAuthenticated = createSelector(
  getAuth,
  (state: fromAuth.State) => state.isAuthenticated
);
export const selectError = createSelector(
  getAuth,
  (state: fromAuth.State) => state.errorMessage
);
export const selectUser = createSelector(
  getAuth,
  (state: fromAuth.State) => state.user
);

